import React from "react";
import { SearchIcon } from "../../../icons";

const FilterSearch = ({ placeholder, value, onChange }) => {
  return (
    <div className="relative w-full">
      <input
        type="text"
        className="w-full border border-grey-500 text-grey-600 typo-body-3 py-[6px] px-2 rounded-md placeholder:text-grey-600  focus:border-purple-800 active:outline-none focus:outline-none focus:ring-0 active:ring-0"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      ></input>
      <SearchIcon className="absolute top-[9px] right-[9px] w-4 h-4" />
    </div>
  );
};

FilterSearch.propTypes = {};

export default FilterSearch;
